import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["radio", "scheduledFields", "scheduledInput"]

  connect() {
    this.toggleScheduledFields()
  }

  toggleScheduledFields() {
    // Find the checked radio button
    const checkedRadio = this.radioTargets.find(radio => radio.checked)

    if (checkedRadio && checkedRadio.value === "true") {
      // Show scheduled fields and make input required
      this.scheduledFieldsTarget.classList.remove("hidden")
      this.scheduledInputTarget.required = true
    } else {
      // Hide scheduled fields and remove required attribute
      this.scheduledFieldsTarget.classList.add("hidden")
      this.scheduledInputTarget.required = false
    }
  }

  toggle(event) {
    this.toggleScheduledFields()
  }
}
